import { Global } from '@emotion/react'
import { getPublicPath } from 'utils/routes'

export const Fonts = () => (
  <>
    <Global
      styles={`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');`}
    />
    <Global
      styles={`
      @font-face {
        font-family: 'Lato';
        src: url(${getPublicPath('/fonts/Lato-Black.woff2')}) format('woff2');
        font-weight: 900;
        font-style: normal;
        font-stretch: normal;
      }
      @font-face {
        font-family: 'Lato';
        src: url(${getPublicPath('/fonts/Lato-Bold.woff2')}) format('woff2');
        font-weight: 700;
        font-style: normal;
        font-stretch: normal;
      }
      @font-face {
        font-family: 'Lato';
        src: url(${getPublicPath(
          '/fonts/Lato-Semibold.woff2'
        )}) format('woff2');
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
      }
      @font-face {
        font-family: 'Lato';
        src: url(${getPublicPath('/fonts/Lato-Medium.woff2')}) format('woff2');
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
      }
      @font-face {
        font-family: 'Lato';
        src: url(${getPublicPath('/fonts/Lato-Regular.woff2')}) format('woff2');
        font-weight: 400;
        font-style: normal;
        font-stretch: normal;
      }
      @font-face {
        font-family: 'FiraCode';
        src: url(${getPublicPath(
          '/fonts/FiraCode-Regular.woff2'
        )}) format('woff2');
        font-weight: 400;
        font-style: normal;
        font-stretch: normal;
      }
      @font-face {
        font-family: 'CarbonOT';
        src: url(${getPublicPath(
          '/fonts/CarbonOT-Bold.woff2'
        )}) format('woff2');
        font-weight: 700;
        font-style: normal;
        font-stretch: normal;
      }
      `}
    />
  </>
)
